import { Component } from '@angular/core';
import { AccountItemsVouchersListComponent } from 'libs/shared/src/lib/component/account-items/account-items-vouchers-list.component';

@Component({ standalone: false, selector: 'app-account-items-vouchers-list', templateUrl: './account-items-vouchers-list.component.html' })
export class CustomAccountItemsVouchersListComponent extends AccountItemsVouchersListComponent {}
